import React, { useState, useMemo, useCallback } from "react"
import { observer } from "mobx-react-lite"
import { useTheme } from '~/ui/styled'
import { KeyboardAvoidingView, Platform, ScrollView } from "~/ui/primitives"
import { PrivacyModal } from "~modals/privacy-modal"
import { ServiceContractModal } from "~modals/service-contract-modal"
import { Flex, StartFlex, CenterFlex, Text, Button } from "~components/El"
import { Tabs } from "~components/Tabs"
import { AuthLayout, PasswordStrengthAnimated } from "~components/Layout"
import { CheckBox } from "~widgets/check-box"
// import { alertError } from "~utils/alert"
// import { globalToast } from "~utils"
import { useStores } from "~models"
import useNavigation from "~hooks/useNavigation"
import { rules, validateSingle } from "~utils/validator"
import { scrollViewFillStyle } from "~/ui/scroll-layout"
import Username from "./components/username"
import Password from "./components/password"
import Email from "./components/email"
import Phone from "./components/phone"
// import Captcha from "./components/captcha"

const tabs: string[] = ["邮箱注册", "手机注册"]
const Register: React.FC = () => {
  const theme = useTheme()
  const navigation = useNavigation()
  const { authStore, configStore } = useStores()
  const [tab, setTab] = useState("邮箱注册")
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [, setCaptcha] = useState("") // 验证码（预留）
  const [isAgreePrivacy, setIsAgreePrivacy] = useState(authStore.haveBeenPassPrivacy)
  const [isServiceContractModalVisible, setIsServiceContractModalVisible] = useState(false)
  const [isPrivacyModalVisible, setIsPrivacyModalVisible] = useState(false)
  const legalPanelOpen = isServiceContractModalVisible || isPrivacyModalVisible

  const openServiceContract = useCallback(() => {
    setIsPrivacyModalVisible(false)
    setIsServiceContractModalVisible(true)
  }, [])

  const openPrivacy = useCallback(() => {
    setIsServiceContractModalVisible(false)
    setIsPrivacyModalVisible(true)
  }, [])

  const active = useMemo(() => {
    if (!isAgreePrivacy) {
      return false
    }
    const nameOk = !validateSingle(rules.displayname, username)
    const passwordOk = !validateSingle(rules.password, password)
    const confirmOk =
      !validateSingle(rules.password, confirmPassword) && password === confirmPassword
    if (!nameOk || !passwordOk || !confirmOk) {
      return false
    }
    if (tab === "手机注册") {
      return !validateSingle(rules.phone, phone)
    }
    return !validateSingle(rules.email, email)
  }, [tab, username, password, confirmPassword, phone, email, isAgreePrivacy])
  const onRegister = () => {
    const params: any = {}
    if (tab === "手机注册") {
      params.name = username
      params.phone = phone
      params.username = username
      params.password = password
      params.repeat_password = confirmPassword
      params.country_code = "+86"
      params.type = "register"
    } else {
      params.name = username
      params.username = username
      params.password = password
      params.repeat_password = confirmPassword
      params.email = email
      params.type = "register"
    }
    navigation.navigate("VerifyCode", { data: params })
  }

  const onTabPress = (
    item: string | { label: string; value: string; icon?: string; iconColor?: string; iconSize?: number },
  ) => {
    const next = typeof item === "string" ? item : item.value
    if (tab !== next) {
      setUsername("")
      setPassword("")
      setEmail("")
      setPhone("")
      setCaptcha("")
      setTab(next)
    }
  }

  return (
     <AuthLayout
        title="欢迎回来"
        subtitle="加入企鹅平台"
        pageBackground="#fff"
        bottomHeight="82%"
        sidePanelOpen={legalPanelOpen}
        sidePanel={
          <>
            <ServiceContractModal
              embedded
              appName={configStore.appName}
              visible={isServiceContractModalVisible}
              setVisible={setIsServiceContractModalVisible}
            />
            <PrivacyModal
              embedded
              appName={configStore.appName}
              visible={isPrivacyModalVisible}
              setVisible={setIsPrivacyModalVisible}
            />
          </>
        }
      >
        {(() => {
          const form = (
            <StartFlex flexDirection="column" width="100%">
              <Tabs
                tabs={tabs}
                active={tab}
                onChange={(item) => onTabPress(item)}
              />
              {tab === "邮箱注册" && (
                <>
                  <Username value={username} onChange={setUsername} />
                  <Email value={email} onChange={setEmail} />
                  <Password value={password} onChange={setPassword} />
                  <PasswordStrengthAnimated password={password} />
                  <Password label="确认密码" value={confirmPassword} onChange={setConfirmPassword} />
                </>
              )}
              {tab === "手机注册" && (
                <>
                  <Username value={username} onChange={setUsername} />
                  <Phone value={phone} onChange={setPhone} />
                  {/* <Captcha
                    type="phone"
                    name={phone}
                    label="手机验证码"
                    value={captcha}
                    placeholder="请输入手机验证码"
                    onChange={setCaptcha}
                  /> */}
                  <Password value={password} onChange={setPassword} />
                  <PasswordStrengthAnimated password={password} />
                  <Password label="确认密码" value={confirmPassword} onChange={setConfirmPassword} />
                </>
              )}

              <Flex width="100%" mt="20px">
                <CheckBox
                  curValue={isAgreePrivacy}
                  value={true}
                  onClick={() => setIsAgreePrivacy(!isAgreePrivacy)}
                />
                <Text color={theme.colors.secondaryText} fontSize={theme.fontSizes.md} onClick={() => setIsAgreePrivacy(!isAgreePrivacy)}>&nbsp;我已阅读并同意</Text>
                <Button onClick={openServiceContract}>
                  <Text color={theme.colors.primaryText} fontSize={theme.fontSizes.md}>&nbsp;服务条款</Text>
                </Button>
                <Text color={theme.colors.secondaryText} fontSize={theme.fontSizes.md}>和</Text>
                <Button onClick={openPrivacy}>
                  <Text color={theme.colors.primaryText} fontSize={theme.fontSizes.md}>&nbsp;隐私政策</Text>
                </Button>
              </Flex>
              <CenterFlex width="100%" mt="20px">
                <Button
                  width="100%"
                  height="44px"
                  borderRadius="8px"
                  bg={theme.colors.primary}
                  disabled={!active}
                  onClick={onRegister}
                >
                  <Text color={theme.colors.textLight} fontSize={theme.fontSizes.lg} fontWeight="600">注册</Text>
                </Button>
              </CenterFlex>
              <CenterFlex width="100%" mt="30px">
                <Button flexDirection="row" onClick={() => { navigation.navigate("Login") }}>
                  <Text color={theme.colors.text} fontSize={theme.fontSizes.md}>已有账户？</Text>
                  <Text color={theme.colors.primaryText} fontSize={theme.fontSizes.md}>&nbsp;立即登录</Text>
                </Button>
              </CenterFlex>
            </StartFlex>
          )

          const scrollProps = {
            keyboardShouldPersistTaps: "handled" as const,
            contentContainerStyle: {
              paddingTop: 12,
              paddingHorizontal: 20,
              paddingBottom: 24,
            },
          }

          if (Platform.OS === "web") {
            return (
              <ScrollView style={scrollViewFillStyle} {...scrollProps}>
                {form}
              </ScrollView>
            )
          }

          return (
            <KeyboardAvoidingView
              style={{ flex: 1, minHeight: 0 }}
              behavior={Platform.OS === "ios" ? "padding" : "height"}
            >
              <ScrollView style={scrollViewFillStyle} {...scrollProps}>{form}</ScrollView>
            </KeyboardAvoidingView>
          )
        })()}
    </AuthLayout>
  )
}
export default observer(Register)
